@if (pageContent) {
<div id="main-content" tabindex="-1">
  <gb-ui-page-heading [titleText]="pageContent.start_page_title"></gb-ui-page-heading>

  <div class="govuk-width-container">
    <div class="govuk-grid-row">
      <div class="govuk-grid-column-full">
        <h2>{{pageContent.start_page_subtitle}}</h2>
        @if (pageContent.start_page_subtitle_body) {
          <p [innerHTML]="pageContent.start_page_subtitle_body"></p>
        }
        
      </div>
      <div class="govuk-grid-column-full">
        <div [innerHTML]="pageContent.register_a_birth_introduction_text"></div>
        <button type="button" class="govuk-button govuk-button--inverse" (click)="startJourney()">
          Start Now
          <span class="material-icons icon">chevron_right</span>
        </button>
      </div>
    </div>
  </div>
</div>
}